// extracted by mini-css-extract-plugin
module.exports = {"CameraViewerContainer":"CameraViewer_CameraViewerContainer__kZ4jG","CameraViewerSwitcher":"CameraViewer_CameraViewerSwitcher__17Pxv"};